<template>
   <yxt-form :model="formModel" :rules="filedsRules" ref="form">
        <yxt-form-item v-for="item in fileds" :key="item.prop" :label="$t(item.label)" :prop="item.prop">
           <component ref="formRef" :is="item.comp" v-model="formModel[item.prop]" :formModel="formModel" :attrs="item.attrs"></component>
        </yxt-form-item>
    </yxt-form>
</template>
<script>
import { getFiledsComp, getFiledsRules } from './fileds';
import { getTLiveRoomInfo } from './services/http';

export default {
  name: 'LiveForm',
  props: {
    fields: {
      type: Array,
      default: []
    },
    roomId: {
      type: Number,
      default: 0
    },
    liveRoomInfo: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      filedsRules: getFiledsRules(this),
      formModel: {
        type: 'pc',
        inside: {
          inside: 0,
          publishType: 1
        },
        outside: 0,
        teacher: [],
        students: [],
        recorded: 0,
        roomName: '',
        beginTime: '',
        duration: 60,
        liveType: Number(this.$route.name === 'createOMO'),
        cover: `${this.$staticBaseUrl}0f43ff1b/c8ea2516/bgCover.svg`,
        remark: '',
        waterMark: 0,
        showLogo: 1,
        selectOrgIds: []
      },
      rulesChangesKey: ['students', 'inside', 'outside']
    };
  },
  computed: {
    fileds() {
      return getFiledsComp(this.fields, this.formModel);
    },
    hasChoseShareType() {
      const isStudent = this.formModel.students.length > 0 ? 1 : 0;
      return `${isStudent}${this.formModel.inside.inside}${this.formModel.outside}`;
    }
  },
  watch: {
    hasChoseShareType(value) {
      const choseIndex = value.indexOf('1');
      this.rulesChangesKey.forEach(keys => {
        this.filedsRules[keys][0].required = !(choseIndex > -1);
      });
    }
  },
  created() {
    this.formModel.teacher.push({
      id: localStorage.getItem('userId'),
      fullname: localStorage.getItem('fullname')
    });
    if (this.roomId) {
      this.getRoomInfo();
    }
  },
  methods: {
    async getRoomInfo() {
      const res = await getTLiveRoomInfo(this.roomId);
      this.setRoomInfo(res);
    },
    setRoomInfo(res) {
      const liveRoomInfo = Object.assign({}, res);
      liveRoomInfo.type = res.mobile ? 'mobile' : 'pc';
      liveRoomInfo.inside = {
        inside: res.inside,
        publishType: res.publishType
      };
      liveRoomInfo.beginTime = new Date(res.beginTime);
      liveRoomInfo.duration = res.duration / 60;
      Object.keys(this.formModel).forEach(key=>{
        if (liveRoomInfo[key]) {
          this.formModel[key] = liveRoomInfo[key];
        }
      });
    },
    getInstance(fileds) {
      const instances = this.$refs.formRef;
      return instances.find(item=>item.$options.name === fileds);
    },
    validate(...arg) {
      return this.$refs.form.validate(...arg);
    }
  }
};
</script>
<style scoped lang='less'>
 
</style>
